import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import * as styles from './button-group.styles'

type Props = {
  children: ReactNode
  className?: string
}

export const ButtonGroup = ({ children, className }: Props) => {
  const theme = useTheme()

  return (
    <div className={className} css={styles.container(theme)} data-testid="button-group">
      {children}
    </div>
  )
}
